class PopupCartPromotionSection extends HTMLElement {
  constructor() {
    super();
    this.randomNum = Math.floor(Math.random() * 10_000);

    this._initSwiper = this._initSwiper.bind(this);
    this._handleClick = this._handleClick.bind(this);
    this._markAdded = this._markAdded.bind(this);
  }
  connectedCallback() {
    requestAnimationFrame(() => {
      this.swiperEl = this.querySelector(".popup-swiper");
      this._sectionRenderLogic();
      this._markAdded();
      this.addEventListener("click", this._handleClick);
      this._initClosers();
    });
  }

  disconnectedCallback() {
    window.removeEventListener("resize", this._initSwiper);
    this.removeEventListener("click", this._handleClick);
    if (window.swiperLoader) {
      window.swiperLoader.cleanup(this);
    }
  }

  _sectionRenderLogic() {
    if (!this.swiperEl) return;

    const initSwiper = () => {
      window.swiperLoader.initImmediately(this._initSwiper);
    };

    if (window.swiperLoader) {
      initSwiper();
    } else {
      window.addEventListener("swiperloader:ready", initSwiper, { once: true });
    }

    window.addEventListener("resize", () => {
      if (this.swiper && window.Swiper) {
        this._initSwiper(window.Swiper);
      }
    });
  }

  _initSwiper(Swiper) {
    if (!Swiper || !this.swiperEl) return;
    if (window.innerWidth < 768) return;

    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
    const swiperId = `popup-swiper-${this.randomNum}`;

    const arrowLeft = this.querySelector(".swiper-button-prev");
    const arrowRight = this.querySelector(".swiper-button-next");

    if (arrowLeft && arrowRight) {
      arrowLeft.classList.add(`${swiperId}-arrow-left`);
      arrowRight.classList.add(`${swiperId}-arrow-right`);
    }

    this.swiperEl.classList.add(swiperId);

    if (this.swiper?.destroy) this.swiper.destroy(true, true);

    this.swiper = new Swiper(`.${swiperId}`, {
      slidesPerView: "auto",
      spaceBetween: 16,
      navigation: {
        prevEl: `.${swiperId}-arrow-left`,
        nextEl: `.${swiperId}-arrow-right`,
      },
    });
  }

  async _markAdded() {
    try {
      const cart = await fetch(window.Shopify.routes.root + "cart.js").then(
        (r) => r.json(),
      );
      const inCart = new Set(cart.items.map((it) => String(it.id)));

      this.querySelectorAll(".popup-product__button").forEach((btn) => {
        const id = btn.dataset.id;
        if (!id || !inCart.has(id)) return;

        btn.classList.add("added");
        const spanMain = btn.querySelector(".popup-button__main");
        spanMain
          ? (spanMain.textContent = "Added")
          : (btn.textContent = "Added");
        btn.disabled = true;
      });
    } catch (e) {
      console.error("Cannot fetch cart:", e);
    }
  }

  _initClosers() {
    this.querySelectorAll(".custom-popup__close, .popup-button--close").forEach(
      (el) => {
        el.addEventListener("click", () => {
          this.hide();
        });
      },
    );
  }

  hide() {
    this.classList.add("hidding");
    setTimeout(() => {
      this.classList.remove("show");
      this.classList.remove("hidding");
    }, 300);
  }

  show() {
    this.classList.add("showing");
    setTimeout(() => {
      this.classList.add("show");
      this.classList.remove("showing");
    }, 100);
  }

  _handleClick(e) {
    const btn = e.target.closest(".popup-product__button");
    if (!btn || btn.classList.contains("added")) return;

    const variantId = btn.dataset.id;
    if (!variantId) return;

    (async (id) => {
      const formData = {
        items: [{ id: Number(id), quantity: 1 }],
      };

      try {
        const response = await fetch(
          window.Shopify.routes.root + "cart/add.js",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(formData),
          },
        );

        if (!response.ok) throw new Error(`HTTP ${response.status}`);

        const result = await response.json();

        btn.classList.add("added");
        btn.textContent = "Added";
      } catch (error) {
        console.error("Add to cart error:", error);
      }
    })(variantId);
  }
}

customElements.define(
  "popup-cart-promotion-section",
  PopupCartPromotionSection,
);
